import classNames from 'classnames';

import { Text, TextProps } from '../../../text/text.component';

interface ColumnContainerTextProps {
  textProps: TextProps;
  className?: string;
}

export const ColumnContainerText = ({ className, textProps }: ColumnContainerTextProps) => {
  return (
    <div
      data-testid="snowflake-column-container-text"
      className={classNames('snowflake-column-container-text', className)}
    >
      <Text {...textProps} isInEditor={false} />
    </div>
  );
};
